import $ from 'jquery';

const namespace = 'megamenu';

export default class MegaMenu {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          item: '.megamenu__item',
        },
        classes: {
          active: 'is-open',
        },
      },
      options,
    );

    this.$el = $(el);
    this.$items = $(this.options.selectors.item, this.$el);

    this.bind();
    this.getNavWidth();
  }

  bind() {
    $(document).on(
      `touchstart.item.${namespace}`,
      this.handleTouchStart.bind(this),
    );

    this.$el.on(
      `click.item.${namespace}`,
      this.options.selectors.item,
      this.handleClick.bind(this),
    );
  }

  getNavWidth() {
    const navList = document.querySelector('.megamenu__nav-list');
    const firstEl = navList.firstElementChild;
    const lastEl = navList.lastElementChild;
    const navWidth = lastEl.getBoundingClientRect().right - firstEl.getBoundingClientRect().left;
    const drops = Array.from(document.querySelectorAll('.megamenu__drop'));
    drops.forEach(drop => {
      if (drop.classList.contains('count-1') || drop.classList.contains('count-2')) {
        drop.style.width = `${navWidth}px`;
      }
    });
  }

  /**
   * @param {Event} event
   */
  handleClick(event) {
    if (this.touch) {
      event.preventDefault();
    }
  }

  /**
   * @param {Event} event
   */
  handleTouchStart(event) {
    const {target} = event;
    const $target = $(target);

    const $match = this.$items.filter((_, el) => {
      return $(el).has($target).length >= 1;
    });

    if ($match.hasClass(this.options.classes.active)) {
      this.touch = false;
    } else {
      this.touch = true;
    }

    this.$items.removeClass(this.options.classes.active);
    $match.addClass(this.options.classes.active);
  }

  destroy() {
    $(document).off(`touchstart.item.${namespace}`);
    this.$el.off(`click.item.${namespace}`);
    this.$items.removeClass(this.options.classes.active);
  }
}
